export const ApiTags = {
    Company: 'Company',
    CompanyAccounts: 'CompanyAccounts',
    CompanyAccountsFiles: 'CompanyAccountsFiles',
    CompanyBookLegalization: 'CompanyBookLegalization',
    CompanyBookLegalizationFiles: 'CompanyBookLegalizationFiles',
    CompanyFiles: 'CompanyFiles',
    CompanyTaxReturn: 'CompanyTaxReturn',
    CompanyTaxReturnFiles: 'CompanyTaxReturnFiles',
    Consultation: 'Consultation',
    CryptoReport: 'CryptoReport',
    Employments: 'Employments',
    IdentityVerification: 'IdentityVerification',
    Profile: 'Profile',
    QuarterlyTaxReturns: 'QuarterlyTaxReturns',
    SocialSecurityProfile: 'SocialSecurityProfile',
    TaxOfficeReferenceNumber: 'TaxOfficeReferenceNumber',
    TaxRegistration: 'TaxRegistration',
    WorkActivities: 'WorkActivities',
    WorkActivityRegistrations: 'WorkActivityRegistrations',
    WorkActivityRegistrationFiles: 'WorkActivityRegistrationFiles',
} as const
